import React, {useEffect} from 'react';
import {Link} from "react-router-dom";

const ViewProjectButton = ({handleMenuClick, id}) => {
  
  return (
    <Link to={`/portfolio/${id}`} onClick={handleMenuClick}>
      <button id={id} className="btn-snormal">
        VIEW PROJECT
      </button>
    </Link>
  )
}

const Portfolio = ({handleMenuClick, projectsList}) => {
  useEffect(() => {
    window.scrollTo(0, 0); // scrolls to top when component mounts
  }, []);
  
const projectComponentsList = projectsList.map(project => 
    <article key={project.id} className="portfolio-article">
          <img className="portfolio-image-preview" src={project.image}/>
          
          <div>
            <h2>
              {project.title}
            </h2>
            
            <p className="body2 opacity80">
              {project.description}
            </p>
            
            <ViewProjectButton handleMenuClick={handleMenuClick} id={project.title} />
          </div>
    </article> 
  
  );
  
  return (
    <>
    <main>
      <section className="portfolio-section">
          
        {projectComponentsList}
          
      </section>
    </main>
    </>
  );
}

export default Portfolio;

